import { MetaData } from '@thive/fddm-types';

import { logger } from '@/modules/common/logging/logger';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';

type RevisionFileStorageMetaData = Pick<MetaData, 'projectId' | 'alternativeId' | 'revisionId'>;

/**
 * @description returns the base path used for storing files related to a revision in the file API.
 * Uses the supplied revision metadata, or the currently loaded revision when omitted.
 *
 * Returns in this format:
 *
 * '<projectId>/<layoutAlternativeId>/<revisionId>'
 */
export const buildRevisionFileStorageBasePath = (
  metaData?: RevisionFileStorageMetaData,
): string | undefined => {
  const revisionMetaData = metaData ?? useFloorplanDesignStore.getState().metaData;
  const { projectId, alternativeId, revisionId } = revisionMetaData;

  if (!projectId || !alternativeId || !revisionId) {
    logger.error('Can not create basePath for file storage. Expected revision metadata.');
    return;
  }

  return formatRevisionFileStorageBasePath(projectId, alternativeId, revisionId);
};

export const formatRevisionFileStorageBasePath = (
  projectId: string,
  alternativeId: string,
  revisionId: string,
) => `${projectId}/${alternativeId}/${revisionId}`;
